<template>
  <div>
    <div style="border-top: 0.1rem solid #ededed;"></div>
    <div class="hotComments" >
      <div class="hot_top">
        <div class="hotLogo">热门评论</div>
      </div>
      <commentContent :items="hotComments" :govImage="govImage"></commentContent>
    </div>
  </div>

</template>
<script>
  import utils from '../../tool/utils'
  import commentContent from './commentContent'
  export default{
    props: ['hotComments', 'govImage', 'themeColor'],
    mounted () {

    },
    filters: {
      parseDateTime: function (t) {
        return utils.parseDateTime(t)
      },
      parseSpace: function (t) {
        return utils.parseSpace(t)
      },
      parseCount1: function (t) {
        return utils.parseCount(t)
      }
    },
    components: {
      commentContent
    }
  }
</script>
<style scoped>
  .hotComments {
    margin: 0.4rem 0.3rem 0.1rem;
  }
  .hot_top {
    width: 100%;
    /*height:0.5rem;*/
    overflow: hidden;
  }
  .hotLogo{
    height: 0.3rem;
    line-height: 0.3rem;
    font-size: 0.3rem;
    border-left: 0.04rem solid var(--themeColor);
    padding-left: 0.1rem;
  }
</style>



// WEBPACK FOOTER //
// hotComments.vue?042304b8